import AbstractApiService from 'src/services/abstractApiService';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { SupplierStatus } from 'src/supplier/types';
import { api } from 'src/supplier/utils/supplierApi';
import { dynamicObj } from 'pages/assets';
import { DOC2API_URL } from 'src/pages/APIs';

type SupplierResponse<T = any> = {
  success: boolean;
  message: string;
  data: T;
};

export default class SupplierDataApiService extends AbstractApiService {
  public constructor() {
    super({});
  }
  public async CheckSupplierOnline(supplier_as_org_id: any): Promise<void> {
    return super.get(
      api.get_supplier_online_detail +
        '?' +
        'supplier_as_org_id=' +
        supplier_as_org_id,
    );
  }
  public async syncDatafromM3(data: dynamicObj): Promise<void> {
    const newData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      newData.append(key, value);
    }
    return super.post(api.get_sync_data_m3, newData);
  }
  public async getOrgSupplierDetails(
    oldId: string,
    id: string,
  ): Promise<SupplierResponse> {
    return super.get(
      api.get_organisation_supplier_detail + '/' + oldId + '/' + id,
    );
  }

  public async getSupplierDetailFile(file_path: string): Promise<Blob> {
    return super.get(api.get_supplier_detail_file + '?file_path=' + file_path, {
      responseType: 'blob',
    });
  }

  public async uploadFile(
    id: string,
    file: Blob,
    type: string,
  ): Promise<SupplierResponse<dynamicObj>> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('document_type', type);
    formData.append('supplier_as_org_id', id);
    return super.post(api.upload_document, formData);
  }

  public async deleteFile(id: string, type: string): Promise<SupplierResponse> {
    const formData = new FormData();
    formData.append('document_type', type);
    formData.append('supplier_as_org_id', id);
    return super.post(api.delete_document, formData);
  }

  public async updateSupplierData(data: dynamicObj): Promise<SupplierResponse> {
    return super.post(api.update_supplier_details, data);
  }

  public async supplierSendEmail(data: any): Promise<any> {
    return super.post(
      DOC2API_URL + '/supplier/send_email_supplier_detail',
      data,
    );
  }

  public async sendForApproval(data: dynamicObj): Promise<SupplierResponse> {
    const newData = new FormData();
    newData.append('supplier_as_org_id', data.supplier_as_org_id);
    newData.append('supplier_lookup_record_id', data.supplier_lookup_record_id);
    newData.append('parent_org_id', data.parent_org_id);
    return super.post(api.send_for_approval, newData);
  }
  public async reject(data: dynamicObj): Promise<SupplierResponse> {
    const newData = new FormData();
    newData.append('supplier_as_org_id', data.supplier_as_org_id);
    newData.append('supplier_lookup_record_id', data.supplier_lookup_record_id);
    newData.append('message', data.message);
    return super.post(api.supplier_reject, newData);
  }
  public async approve(data: dynamicObj): Promise<SupplierResponse> {
    const newData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      newData.append(key, value);
    }
    return super.post(api.supplier_approve, newData);
  }
}
